import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Protected from "./utils/PrivateRoute"
import HomeRoute from "./utils/HomeRoute"
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Resetpassword from "./pages/Resetpassword";
import Forgotpassword from "./pages/Forgotpassword";
import MainLayout from "./components/MainLayout";
import Newslist from "./pages/Newslist";
import Newscatlist from "./pages/Newscatlist";

import NewsRepoterList from "./pages/NewsRepoterList";
import AddNewsRepoter from "./pages/AddNewsRepoter";

import AddNews from "./pages/AddNews";
import AddNewscat from "./pages/AddNewscat";

import Interviewlist from "./pages/Interviewlist";
import AddInterview from "./pages/AddInterview";

import InvestmentOpportunityList from "./ppp/pages/InvestmentOpportunityList";
import AddInvestmentOpportunity from "./ppp/pages/AddInvestmentOpportunity";


import TourismPolicyList from "./ppp/pages/TourismPolicyList";
import AddTourismPolicy from "./ppp/pages/AddTourismPolicy";


import AddEbrouchers from "./ppp/pages/AddEbrouchers";
import EbrouchersList from "./ppp/pages/EbrouchersList";


import PhotographsList from "./ppp/pages/PhotographsList";
import AddPhotographs from "./ppp/pages/AddPhotographs";


import VideosList from "./ppp/pages/VideosList";
import AddVideos from "./ppp/pages/AddVideos";


import VerifyedStakeholderList from "./ppp/pages/VerifyedStakeholderList";
import UnerifyedStakeholderList from "./ppp/pages/UnerifyedStakeholderList";

import Associationlist from "./pages/Associationlist";
import AddAssociation from "./pages/Addassociation";

import TvProgramtList from "./pages/TvProgramtList";
import AddTvProgram from "./pages/addTvProgram";

import RadioProgramlist from "./pages/RadioProgramlist";
import AddRadioProgram from "./pages/addRadioProgram";

import PackageList from "./pages/PackageList";

import PPPList from "./pages/PPPList";
import AddPPP from "./pages/addPPP";

import LiveList from "./pages/LiveEventList";
import PastEventList from "./pages/PastEventList";

import AssoMainLayou from "./Association/components/MainLayout";
import AssoDashboard from "./Association/pages/Dashboard";
import AddMember from "./Association/pages/AddMember";
import AddBulkMember from "./Association/pages/AddBulkMember";
import AddCircular from "./Association/pages/AddCircular";
import AddUpdate from "./Association/pages/AddUpdate";
import AddBoard from "./Association/pages/AddBoard";
import AddChapters from "./Association/pages/AddChapters";
import CircularList from "./Association/pages/CircularList";
import MemberList from "./Association/pages/MemberList";
import BoardList from "./Association/pages/BoardList";
import ChapterList from "./Association/pages/ChapterList";
import Appointment from "./Association/pages/Appointment";
import AppointmentList from "./Association/pages/AppointmentList";
import AddLuxuryTransport from "./pages/addLuxuryTransport";
import LuxuryTransportList from "./pages/LuxuryTransportList";
import AddLuxuryHotel from "./pages/AddLuxuryHotel";
import LuxuryHotelList from "./pages/LuxuryHotelList";
import UpdateList from "./Association/pages/UpdateList";
import TransMainLayou from "./LururyTransport/components/MainLayout";
import HotelMainLayou from "./Luxuryhotel/components/MainLayout";
import NewsRepoterMainLayou from "./NewsRepoter/components/MainLayout";
import PPPMainLayou from "./ppp/components/MainLayout";


import TransDashboard from "./LururyTransport/pages/Dashboard";
import HotelDashboard from "./Luxuryhotel/pages/Dashboard";
import NewsRepoterDashboard from "./NewsRepoter/pages/Dashboard";
import PPPDashboard from "./ppp/pages/Dashboard";

import AddAdvisoryBoard from "./pages/addAdvisoryBoard";
import ListAdvisoryBoard from "./pages/ListAdvisoryBoard";

import AddHotel from "./Luxuryhotel/pages/AddHotel";
import LLuxuryHotelList from "./Luxuryhotel/pages/LuxuryHotelList";
import Dmc from "./pages/Adddmc";
import UFFTA from "./pages/Uftaa";
import UfftaApproval from "./pages/UfftaApproval";

import AddAdvertisement from "./pages/AddAdvertisement";
import AdvertisementList from "./pages/AdvertisementList";
import AddGalleryImage from "./pages/AddGalleryImage";
import GalleryImagelist from "./pages/GalleryImagelist";
import AddCountry from "./TwoCampus/pages/AddCountry";
import CountryList from "./TwoCampus/pages/CountryList";

import AddCountryCategory from "./TwoCampus/pages/AddCountryCategory";
import CountryCategoryList from "./TwoCampus/pages/CountryCategoryList";

import AddCountryData from "./TwoCampus/pages/AddCountryData";
import CountryDataList from "./TwoCampus/pages/CountryDataList";

import AddTransport from "./LururyTransport/pages/AddTransport";
import TransportList from "./LururyTransport/pages/TransportList";
import DMCList from './pages/DMCList';
import TailorMade from './pages/TailorMade';
import AsegoBookingList from "./pages/AsegoBookingList";
import VillaBookingList from "./pages/VillaBookingList";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeRoute Component={Login} />} />
        <Route path="/dmc" element={<Dmc />} />
        <Route path="/UFFTA" element={<UFFTA />} />
        <Route path="/UFFTA/MemberApproval" element={<UfftaApproval />} />
        <Route path="/reset-password" element={<Resetpassword />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route path="/admin" element={<Protected Component={MainLayout} />}>
          <Route index element={<Dashboard />} />

          <Route path="DMC-list" element={<DMCList />} />
          <Route path="Tailor-Made" element={<TailorMade />} />
          <Route path="Asego-Booking-list" element={<AsegoBookingList />} />
          <Route path="Villa-Booking-list" element={<VillaBookingList />} />
          <Route path="News-list" element={<Newslist />} />
          <Route path="Add-News" element={<AddNews />} />
          <Route path="Add-News/:id" element={<AddNews />} />

          <Route path="News-Repoter-List" element={<NewsRepoterList />} />
          <Route path="Add-News-Repoter" element={<AddNewsRepoter />} />
          <Route path="Add-News-Repoter/:id" element={<AddNewsRepoter />} />

          <Route path="News-category-list" element={<Newscatlist />} />
          <Route path="News-category" element={<AddNewscat />} />
          <Route path="News-category/:id" element={<AddNewscat />} />

          <Route path="Interview-list" element={<Interviewlist />} />
          <Route path="Add-Interview" element={<AddInterview />} />
          <Route path="Add-Interview/:id" element={<AddInterview />} />

          <Route path="TvProgram-list" element={<TvProgramtList />} />
          <Route path="Add-TvProgram" element={<AddTvProgram />} />
          <Route path="Add-TvProgram/:id" element={<AddTvProgram />} />

          <Route path="Radio-Program-list" element={<RadioProgramlist />} />
          <Route path="Add-Radio-Program" element={<AddRadioProgram />} />
          <Route path="Add-Radio-Program/:id" element={<AddRadioProgram />} />
          <Route path="Featured-Packages-list" element={<PackageList />} />

          <Route path="Association-list" element={<Associationlist />} />
          <Route path="Add-Association" element={<AddAssociation />} />
          <Route path="Add-Association/:id" element={<AddAssociation />} />

          <Route path="Luxury-Transport-list" element={<LuxuryTransportList />} />
          <Route path="Add-Luxury-Transport" element={<AddLuxuryTransport />} />
          <Route path="Add-Luxury-Transport/:id" element={< AddLuxuryTransport />} />

          <Route path="Luxury-Hotel-list" element={<LuxuryHotelList />} />
          <Route path="Add-Luxury-Hotel" element={<AddLuxuryHotel />} />
          <Route path="Add-Luxury-Hotel/:id" element={< AddLuxuryHotel />} />

          <Route path="Advisory-Board-list" element={<ListAdvisoryBoard />} />
          <Route path="Add-Advisory-Board" element={<AddAdvisoryBoard />} />
          <Route path="Add-Advisory-Board/:id" element={< AddAdvisoryBoard />} />

          <Route path="Advertisement-list" element={<AdvertisementList />} />
          <Route path="Add-Advertisement" element={<AddAdvertisement />} />
          <Route path="Add-Advertisement/:id" element={< AddAdvertisement />} />

          <Route path="GalleryImage-list" element={<GalleryImagelist />} />
          <Route path="Add-GalleryImage" element={<AddGalleryImage />} />


          <Route path="Country-List" element={<CountryList />} />
          <Route path="Add-Country" element={<AddCountry />} />
          <Route path="Add-Country/:id" element={< AddCountry />} />

          <Route path="Country-Category-List" element={<CountryCategoryList />} />
          <Route path="Add-Country-Category" element={<AddCountryCategory />} />
          <Route path="Add-Country-Category/:id/:secondId" element={< AddCountryCategory />} />


          <Route path="Country-Data-List" element={<CountryDataList />} />
          <Route path="Add-Country-Data" element={<AddCountryData />} />
          <Route path="Add-Country-Data/:id/:cityId/:subcollectionId" element={< AddCountryData />} />

          <Route path="PPP-List" element={<PPPList />} />
          <Route path="Add-PPP" element={<AddPPP />} />
          <Route path="Add-PPP/:id" element={< AddPPP />} />

          <Route path="All-Scedule-Live-Event" element={<LiveList />} />
          <Route path="All-Past-Live-Event" element={< PastEventList />} />

        </Route>

        <Route path="/association" element={<Protected Component={AssoMainLayou} />}>
          <Route index element={<AssoDashboard />} />
          <Route path="Member-list" element={<MemberList />} />
          <Route path="Add-Member" element={<AddMember />} />
          <Route path="bulk-Member" element={<AddBulkMember />} />
          <Route path="Add-Member/:id" element={<AddMember />} />

          <Route path="Update-list" element={<UpdateList />} />
          <Route path="Add-Update" element={<AddUpdate />} />
          <Route path="Add-Update/:id" element={<AddUpdate />} />

          <Route path="Circular-list" element={<CircularList />} />
          <Route path="Add-Circular" element={<AddCircular />} />
          <Route path="Add-Circular/:id" element={< AddCircular />} />


          <Route path="Boards-list" element={<BoardList />} />
          <Route path="Add-Boards" element={<AddBoard />} />
          <Route path="Add-Boards/:id" element={< AddBoard />} />


          <Route path="Chapters-list" element={<ChapterList />} />
          <Route path="Add-Chapters" element={<AddChapters />} />
          <Route path="Add-Chapters/:id" element={< AddChapters />} />
          <Route path="Live-Appointment" element={< Appointment />} />
          <Route path="Live-Appointment/:id" element={< Appointment />} />
          <Route path="Appointment-List" element={< AppointmentList />} />



        </Route>

        <Route path="/Transport" element={<Protected Component={TransMainLayou} />}>
          <Route index element={<TransDashboard />} />
          <Route path="Transportlist" element={<TransportList />} />
          <Route path="AddTransport" element={<AddTransport />} />
          <Route path="AddTransport/:id" element={< AddTransport />} />



        </Route>


        <Route path="/Hotel" element={<Protected Component={HotelMainLayou} />}>
          <Route index element={<HotelDashboard />} />
          <Route path="Hotel-list" element={< LLuxuryHotelList />} />
          <Route path="AddHotel" element={<AddHotel />} />
          <Route path="AddHotel/:id" element={<AddHotel />} />
        </Route>

        <Route path="/repoter" element={<Protected Component={NewsRepoterMainLayou} />}>
          <Route index element={<NewsRepoterDashboard />} />
          <Route path="News-list" element={<Newslist />} />
          <Route path="Add-News" element={<AddNews />} />
          <Route path="Add-News/:id" element={<AddNews />} />

          <Route path="News-Repoter-List" element={<NewsRepoterList />} />
          <Route path="Add-News-Repoter" element={<AddNewsRepoter />} />
          <Route path="Add-News-Repoter/:id" element={<AddNewsRepoter />} />

          <Route path="News-category-list" element={<Newscatlist />} />
          <Route path="News-category" element={<AddNewscat />} />
          <Route path="News-category/:id" element={<AddNewscat />} />

          <Route path="Interview-list" element={<Interviewlist />} />
          <Route path="Add-Interview" element={<AddInterview />} />
          <Route path="Add-Interview/:id" element={<AddInterview />} />

          <Route path="GalleryImage-list" element={<GalleryImagelist />} />
          <Route path="Add-GalleryImage" element={<AddGalleryImage />} />
        </Route>

        <Route path="/members" element={<Protected Component={NewsRepoterMainLayou} />}>
        </Route>

        <Route path="/ppp" element={<Protected Component={PPPMainLayou} />}>
          <Route index element={<PPPDashboard />} />

          <Route path="Investment-Opportunity-list" element={<InvestmentOpportunityList />} />
          <Route path="Add-Investment-Opportunity" element={<AddInvestmentOpportunity />} />
          <Route path="Add-Investment-Opportunity/:id" element={<AddInvestmentOpportunity />} />

          <Route path="Tourism-Policy-list" element={<TourismPolicyList />} />
          <Route path="Add-Tourism-Policy" element={<AddTourismPolicy />} />
          <Route path="Add-Tourism-Policy/:id" element={<AddTourismPolicy />} />



          <Route path="Photographs-List" element={<PhotographsList />} />
          <Route path="Add-Photographs" element={<AddPhotographs />} />


          <Route path="Ebrouchers-List" element={<EbrouchersList />} />
          <Route path="Add-Ebrouchers" element={<AddEbrouchers />} />



          <Route path="Videos-List" element={<VideosList />} />
          <Route path="Add-Videos" element={<AddVideos />} />



          <Route path="Verifyed-Stakeholder" element={<VerifyedStakeholderList />} />
          <Route path="Unerifyed-Stakeholder" element={<UnerifyedStakeholderList />} />


        </Route>


      </Routes>
    </Router>
  );
}

export default App;
